<template>
    <app-modal-view @close="discardUnsavedChanges">
        <template #header>
            <div class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <button
                            v-t="'project.create_session'"
                            class="button is-primary is-uppercase"
                            @click="$emit('create-session')"
                        />
                    </div>
                </div>
                <div class="level-item">
                    <h5 v-t="'Sessions.title'" class="title is-size-5" />
                </div>
                <div class="level-right">
                    <div class="level-item buttons">
                        <button
                            v-t="'Buttons.close'"
                            class="button is-danger is-inverted is-uppercase"
                            @click="$emit('close')"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <div class="px-5 py-3">
                <dashboard-sessions-table :sessions="sessions" />
            </div>
        </template>
        <template #footer> </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import DashboardSessionsTable from '@/components/DashboardSessionsTable';
import { fetchItems } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        DashboardSessionsTable,
    },
    props: {},
    data() {
        return { sessions: [] };
    },
    computed: {
        project() {
            return this.$store.getters.project;
        },
    },
    async mounted() {
        let response = await fetchItems(
            `session/mine?project=${this.project._id}`
        ).finally(() => {});
        this.sessions = response.data;
    },
    methods: {},
};
</script>

<style scoped></style>
